import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../../store";
import {
  User,
  Activity,
  Evidence,
  Link,
  File,
  Report
} from "../../../api/classes";
import { Avatar, Typography, List, GridList } from "@material-ui/core";
import CaseReport from "../components/report";
import { DubitoSvc } from "../../../api";
import { GetCaseRequest } from "../../../api/DubitoAPI";
import reports from "src/pages/reports";
import EmptyState from "src/components/emptyState";
interface Props {
  caseId: number;
  reports: Report[];
  style?: React.CSSProperties;
  files: File[];
  links: Link[];
  full?: boolean;
}
class CaseReports extends React.Component<Props> {
  state = {};
  fetchEvidenceDetails() {
    DubitoSvc.getReportAttachments({
      case_id: this.props.caseId,
      test: 1
    } as GetCaseRequest).then(res => {
      //console.log(res);
      if (res.files || res.links) {
        this.setState({ links: res.links, files: res.files });
      }
    });
  }
  componentWillMount() {
    if (this.props.reports && this.props.reports.length > 0) {
      this.fetchEvidenceDetails();
    }
  }
  componentWillReceiveProps(next: Props) {
    if (JSON.stringify(this.props.reports) !== JSON.stringify(next.reports)) {
      if (next.reports && next.reports.length > 0) {
        this.fetchEvidenceDetails();
      }
    }
  }
  render() {
    const { style } = this.props;
    return (
      <GridList cols={this.props.full ? 2 : 1} style={style}>
        {this.props.reports.length === 0 ? (
          <EmptyState message="There is no report yet" />
        ) : (
          this.props.reports.map(a => {
            return (
              <CaseReport
                style={{ margin: 12, height: "100%" }}
                report={a}
                files={this.props.files}
                links={this.props.links}
              />
            );
          })
        )}
      </GridList>
    );
  }
}
function mapStateToProps(state: GlobalState, own: Props) {
  return {};
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseReports);



// WEBPACK FOOTER //
// ./src/pages/cases/detail/reports.tsx